import { defineStore } from 'pinia';

const ERROR_CODES = {
    NETWORK: 'ERR_NETWORK',
    TEMP_REDIRECT: 307,
    UNPROCESSABLE_ENTITY: 422,
    UNAUTHORIZED: 401,
    BAD_REQUEST: 400,
    INTERNAL_SERVER_ERROR: 500,
};

const handleUnprocessableEntity = (error) => {
    const errorBag = {};
    if (error.response?.data?.errors) {
        for (const key in error.response.data.errors) {
            const keys = key.split('.'); // Split the key by '.'
            let current = errorBag;

            // Loop through the keys array and create nested objects
            keys.forEach((k, index) => {
                if (index === keys.length - 1) {
                    current[k] = error.response.data.errors[key][0]; // Assign the error message to the last key
                } else {
                    current[k] = current[k] || {}; // Create a new object if it doesn't exist
                    current = current[k]; // Move to the next level
                }
            });
        }
    }
    return errorBag;
};

export const useErrorStore = defineStore('error', {
    // id: 'error',
    state: () => ({
        error: {},
        showableErrorCodes: [403, 404, 500],
        errorCode: null,
    }),
    getters: {
        formErrors: (state) => {
            if (Object.keys(state.error).length === 0) {
                return [];
            }
            if (
                state.error.response?.status ===
                ERROR_CODES.UNPROCESSABLE_ENTITY
            ) {
                return handleUnprocessableEntity(state.error);
            }
            return [];
        },
        isShowableErrorCode: (state) => {
            return state.showableErrorCodes.includes(state.errorCode) ?? false;
        },
        errorMessage: (state) => {
            if (Object.keys(state.error).length === 0) {
                return '';
            }

            if (state.error.code === ERROR_CODES.NETWORK) {
                return 'Connection error: Unable to reach the server.';
            }

            return state.error.response?.data?.message || '';
        },
    },
    actions: {
        setError(error = {}) {
            this.error = error;
            this.errorCode = this.determineErrorCode(error);
            this.handleError();
        },
        handleError() {
            switch (this.errorCode) {
                case ERROR_CODES.UNPROCESSABLE_ENTITY:
                    // Handle 422 error
                    break;
                case ERROR_CODES.UNAUTHORIZED:
                    // Handle 401 error
                    break;
                case ERROR_CODES.BAD_REQUEST:
                    // Handle 400 error
                    break;
                case ERROR_CODES.INTERNAL_SERVER_ERROR:
                    // Handle network error
                    break;
                case ERROR_CODES.TEMP_REDIRECT:
                    if (this.error?.response?.data?.redirect_url) {
                        // navigateToUrl(this.error.response.data.redirect_url);
                    }
                    break;
                default:
                    // Handle other errors
                    break;
            }
        },
        setErrorCode(code = null) {
            this.errorCode = code;
        },
        determineErrorCode(error) {
            if (error?.response?.status) {
                return error.response.status;
            }
            if (error.code === ERROR_CODES.NETWORK) {
                return ERROR_CODES.INTERNAL_SERVER_ERROR;
            }
            return null;
        },
    },
});
